import React, { createContext, useContext, useMemo, useState } from 'react';
import SearchSource from '~/constants/SearchSource';
import { Nullable } from '~/types';

type KeywordSuggestionContext = Partial<
  Nullable<{
    isStickySearchbar: boolean;
    result: string;
    suggestionIndex: number;
    suggestionsLength: number;
    suggestionText: string;
    textEntered: string;
  }>
>;

type ContextType = {
  keywordSuggestion: KeywordSuggestionContext;
  searchSource: SearchSource;
  setKeywordSuggestion: React.Dispatch<
    React.SetStateAction<KeywordSuggestionContext>
  >;
  setSearchSource: React.Dispatch<React.SetStateAction<SearchSource>>;
};

const defaultContext: ContextType = {
  keywordSuggestion: {},
  searchSource: SearchSource.InitialPageLoad,
  setKeywordSuggestion() {},
  setSearchSource() {}
};

const SearchEventsDataContext = createContext<ContextType>(defaultContext);

export function SearchEventsDataContextProvider({ children }) {
  const [searchSource, setSearchSource] = useState<SearchSource>(
    defaultContext.searchSource
  );
  const [keywordSuggestion, setKeywordSuggestion] =
    useState<KeywordSuggestionContext>({});

  const value = useMemo<ContextType>(
    (): ContextType => ({
      keywordSuggestion,
      searchSource,
      setKeywordSuggestion,
      setSearchSource
    }),
    [keywordSuggestion, searchSource]
  );

  return (
    <SearchEventsDataContext.Provider value={value}>
      {children}
    </SearchEventsDataContext.Provider>
  );
}

export function useKeywordSuggestion() {
  return useContext(SearchEventsDataContext).keywordSuggestion;
}

export function useSearchSource() {
  return useContext(SearchEventsDataContext).searchSource;
}

export default SearchEventsDataContext;
